module.exports = __webpack_public_path__ + "static/media/img-background-modal-form.829963b7.png";